import { styled } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

const MyTablePagination = styled(TablePagination)({
  font: 'DM Sans',
  fontSize: '30px',
});

export { MyTablePagination };
